import {downloadJsonAsCSV} from '../../csv/utils'
import {ColumnTitlesKeys} from '../tasksTable/configurationMenu/constants'
import messageResource from "../../messageResource"
import _ from "underscore"
import {TaskSortBy} from '../constants'
import {DateFormat} from '../../date_format'
import {arrayToMap} from '../../atUtils'
import {WorkflowStatusType} from '../../workflowStatus/constants'
import {columnValue, formatDate, formatTimeDecimal, nameWithArchivedMark} from '../../csv/format'

export function convertTaskListAndSaveAsCsv({projects, customers, tasks, billingTypes, workflowStatuses}, optionalColumns, customFieldsMap, isTWSEnabled) {
    const customerMap = arrayToMap(customers)
    const projectMap = arrayToMap(projects)
    const billingTypesMap = arrayToMap(billingTypes.list)
    const workflowStatusValueMap = {}
    const getWorkflowStatusValue = isTWSEnabled ? workflowStatusExtended : workflowStatusSimple
    workflowStatuses.forEach(item => workflowStatusValueMap[item.id] = getWorkflowStatusValue(item))

    const json = {
        columnNames: csvColumnNames(optionalColumns, customFieldsMap),
        columns: csvColumns(optionalColumns),
        table: csvRows(tasks, optionalColumns, customerMap, projectMap, billingTypesMap, workflowStatusValueMap)
    }
    let fileName = messageResource.getMessage("task.list.export_name.csv", [new DateFormat('MMM dd, yyyy').formatDate(window.currentUserTime())])
    downloadJsonAsCSV([json], fileName)
}

function csvColumnNames(optionalColumns, customFieldsMap) {
    return {
        customer: messageResource.getMessage("common.Customer"),
        project: messageResource.getMessage("common.Project"),
        task: messageResource.getMessage("common.Task"),
        status: messageResource.getMessage("task.list.task_status"),
        ...csvOptionalColumnNames(optionalColumns, customFieldsMap)
    }
}

function csvOptionalColumnNames(optionalColumns, customFieldsMap) {
    return _.object(optionalColumns, _.map(optionalColumns, (item) => {
        if (!!customFieldsMap[item])
            return customFieldsMap[item].title
        else
            return messageResource.getMessage(ColumnTitlesKeys[item])
    }))
}

function csvColumns(optionalColumns) {
    return ["customer", "project", "task", "status", ...optionalColumns]
}

function csvRows(tasks, optionalColumns, customerMap, projectMap, billingTypesMap, workflowStatusValueMap) {
    return _.map(tasks, (task) => {
        return {
            customer: nameWithArchivedMark(customerMap[task.customerId]),
            project: nameWithArchivedMark(projectMap[task.projectId]),
            task: task.name,
            status: workflowStatusValueMap[task.workflowStatusId],
            ...csvMapOptionalColumns(optionalColumns, task, billingTypesMap)
        }
    })
}

function csvMapOptionalColumns(optionalColumns, task, billingTypesMap) {
    let result = {}
    _.each(optionalColumns, (column) => {
        if (!!optionalColumnMapFormatter[column]) {
            result[column] = optionalColumnMapFormatter[column](task, billingTypesMap)
        } else {
            result[column] = columnValue(task[column], value => value)
        }
    })
    return result
}

const optionalColumnMapFormatter = {
    [TaskSortBy.DEADLINE]: (task) => columnValue(task.deadline, formatDate),
    [TaskSortBy.ESTIMATE]: (task) => columnValue(task.estimatedTime, formatTimeDecimal),
    [TaskSortBy.LAST_TRACKING_DATE]: (task) => columnValue(task.lastTTDate, formatDate),
    [TaskSortBy.TYPE_OF_WORK]: (task, billingTypesMap) => billingTypeColumnValue(billingTypesMap[task.typeOfWorkId]),
    [TaskSortBy.CREATION_DATE]: (task) => formatDate(task.creationTimestamp),
    [TaskSortBy.SPENT_TIME]: (task) => formatTimeDecimal(task.spentTime),
}

function workflowStatusSimple(status) {
    return messageResource.getMessage(status.type === WorkflowStatusType.OPEN ? "task.status.open" : "task.status.completed")
}

function workflowStatusExtended(status) {
    const statusPrefix = workflowStatusSimple(status)
    return `${statusPrefix}: ${status.name}`
}

function billingTypeColumnValue(billingType) {
    const category = messageResource.getMessage(billingType.billable ? 'billing_type.billable' : 'billing_type.non_billable')
    return `${category}: ${billingType.name}`
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/utils.js